import { render, staticRenderFns } from "./assignment-modal.vue?vue&type=template&id=279eafe2&scoped=true"
import script from "./assignment-modal.vue?vue&type=script&lang=js"
export * from "./assignment-modal.vue?vue&type=script&lang=js"
import style0 from "./assignment-modal.vue?vue&type=style&index=0&id=279eafe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279eafe2",
  null
  
)

export default component.exports